import { PublicKey } from '@solana/web3.js';

import type { AddSolanaPairRequest } from 'entities/project/api/project/api.types';

export type SolanaPairFormValues = {
  poolAddress: string;
  notes: string;
};

export type SolanaPairFormErrors = Partial<Record<keyof SolanaPairFormValues, string>>;

export const initialSolanaPairFormValues: SolanaPairFormValues = {
  poolAddress: '',
  notes: '',
};

const isCanonicalSolanaAddress = (value: string): boolean => {
  try {
    return new PublicKey(value).toBase58() === value;
  } catch {
    return false;
  }
};

export const validateSolanaPairForm = (values: SolanaPairFormValues): SolanaPairFormErrors => {
  const errors: SolanaPairFormErrors = {};
  const poolAddress = values.poolAddress.trim();

  if (!isCanonicalSolanaAddress(poolAddress)) {
    errors.poolAddress = 'Enter a canonical Solana address';
  }
  if (values.notes.trim().length > 128) {
    errors.notes = 'Notes must not exceed 128 characters';
  }

  return errors;
};

export const toAddSolanaPairRequest = (
  projectId: number,
  values: SolanaPairFormValues,
): AddSolanaPairRequest => {
  const notes = values.notes.trim();
  return {
    projectId,
    dex: 'raydium_amm_v4:solana',
    pool_address: values.poolAddress.trim(),
    ...(notes ? { notes } : {}),
  };
};
